import { render, staticRenderFns } from "./hedbttom.vue?vue&type=template&id=6195c4a0&scoped=true&"
import script from "./hedbttom.vue?vue&type=script&lang=js&"
export * from "./hedbttom.vue?vue&type=script&lang=js&"
import style0 from "./hedbttom.vue?vue&type=style&index=0&id=6195c4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195c4a0",
  null
  
)

export default component.exports